import { createContext } from 'react';
/**
 * A context to expose the TreeController data and handlers.
 */
export var TreeContext = createContext(undefined);
